import { useEffect, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import { useGlobalContext } from "../../../../../Context/Context";
import Gradilista from "./Gradilista";
import PreviewGradiliste from "./PreviewGradiliste";
import GradilistePrethodniMeseci from "./GradilistePrethodniMeseci";
import axios from "axios";
import styles from "../styles";
import CustomCalendarInput from "../CustomCalendarInput";

const now = new Date();

function Pocetna() {
  const [currentTab, setCurrentTab] = useState("AKTIVNO");
  const [gradilisteId, setGradilisteId] = useState("");
  const [currentTabGradiliste, setCurrentTabGradiliste] = useState("TEKUCI_MESEC");
  const [godina, setGodina] = useState(-1);
  const [mesec, setMesec] = useState(-1);
  const [gradilistData, setGradilistData] = useState([]);
  const [isDodavanjeGradiliste, setIsDodavanjeGradiliste] = useState(false);
  const [novoNaziv, setNovoNaziv] = useState("");
  const [novoDatum, setNovoDatum] = useState("");
  const [sviZaposleni, setSviZaposleni] = useState([]);
  const [odabraniZaposleni, setOdabraniZaposleni] = useState([]);

  const { dictionary, baseUrl, selectedMainEntity } = useGlobalContext();

  const fetchGradilista = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/evidencija7/get_gradilista.php`, {
        company_id: selectedMainEntity.company_id,
      });
      if (data.status === 200) setGradilistData(data.data);
    } catch (e) { console.error(e); }
  };

  const fetchLookups = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/evidencija7/get_lookups.php`, {
        company_id: selectedMainEntity.company_id,
      });
      if (data.status === 200) setSviZaposleni(data.zaposleni);
    } catch (e) { console.error(e); }
  };

  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    fetchGradilista();
    fetchLookups();
  }, [selectedMainEntity]);

  const handleClickTekuciMesec = () => {
    setCurrentTabGradiliste("TEKUCI_MESEC");
    setMesec(now.getMonth() + 1);
    setGodina(now.getFullYear());
  };

  const handleClickPrethodniMeseci = () => {
    setMesec(-1); setGodina(-1);
    setCurrentTabGradiliste("PRETHODNI_MESECI");
  };

  const handleDeleteGradiliste = async (id) => {
    try {
      await axios.post(`${baseUrl}/evidencija7/delete_gradiliste.php`, {
        id, company_id: selectedMainEntity.company_id,
      });
      fetchGradilista();
    } catch (e) { console.error(e); }
  };

  const formatDateForApi = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.replace(/\.$/, "").split(".");
    if (parts.length < 3) return null;
    const y = parts[2].length === 2 ? (parseInt(parts[2]) < 50 ? "20" : "19") + parts[2] : parts[2];
    return `${y}-${parts[1]}-${parts[0]}`;
  };

  const toggleZaposlen = (id) => {
    setOdabraniZaposleni(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const handleDodajGradiliste = async () => {
    if (!novoNaziv) return;
    try {
      const { data } = await axios.post(`${baseUrl}/evidencija7/create_gradiliste.php`, {
        company_id: selectedMainEntity.company_id,
        naziv: novoNaziv,
        pocetak: formatDateForApi(novoDatum),
        zaposleni: odabraniZaposleni,
      });
      if (data.status === 200) {
        setNovoNaziv(""); setNovoDatum(""); setOdabraniZaposleni([]);
        setIsDodavanjeGradiliste(false);
        fetchGradilista();
      }
    } catch (e) { console.error(e); }
  };

  return (
    <div style={{ padding: "5px", fontSize: "12px", height: "90%", width: "100%"}}>
      <div style={{ display: "flex", flexDirection: "row", gap: "10px", marginBottom: "20px", height: "40px", justifyContent: "space-between", width: "100%" }}>
        {gradilisteId ? (
          <>
            <div onClick={handleClickTekuciMesec} style={{ width: "40%" }}>
              <Button activation={true} active={currentTabGradiliste === "TEKUCI_MESEC"}>{dictionary["tekuciMesec"]}</Button>
            </div>
            <div onClick={handleClickPrethodniMeseci} style={{ width: "40%" }}>
              <Button activation={true} active={currentTabGradiliste === "PRETHODNI_MESECI"}>{dictionary["prethodniMeseci"]}</Button>
            </div>
          </>
        ) : (
          <>
            <div onClick={() => setCurrentTab("AKTIVNO")} style={{ width: "15vw" }}>
              <Button activation={true} active={currentTab === "AKTIVNO"}><span style={{ fontWeight: "bold" }}>{dictionary["aktivno"]}</span></Button>
            </div>
            <div onClick={() => setCurrentTab("ARHIVIRANO")} style={{ width: "15vw" }}>
              <Button activation={true} active={currentTab === "ARHIVIRANO"}><span style={{ fontWeight: "bold" }}>{dictionary["arhivirano"]}</span></Button>
            </div>
          </>
        )}
      </div>

      {gradilisteId ? (
        currentTabGradiliste === "TEKUCI_MESEC" || (mesec != -1 && godina != -1) ? (
          <PreviewGradiliste
            gradilisteId={gradilisteId} setGradilisteId={setGradilisteId}
            godina={godina} mesec={mesec} setGodina={setGodina} setMesec={setMesec}
          />
        ) : (
          <GradilistePrethodniMeseci
            gradilisteId={gradilisteId} setGodina={setGodina} setMesec={setMesec}
            setGradilisteId={setGradilisteId} setCurrentTabGradiliste={setCurrentTabGradiliste}
          />
        )
      ) : (
        <>
          <div style={{ overflowY: "auto", height: `calc(100% - ${isDodavanjeGradiliste ? "220" : "70"}px)`, backgroundColor: "white", border: "1.5px solid #9f9f9f", padding: "5px" }}>
            <Gradilista
              currentTab={currentTab} setGradilisteId={setGradilisteId}
              setMesec={setMesec} setGodina={setGodina}
              data={gradilistData} onRefresh={handleDeleteGradiliste}
            />
          </div>

          <div style={{ marginTop: "10px" }}>
            {isDodavanjeGradiliste ? (
              <div>
                {/* Red 1 — naziv i datum */}
                <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
                  <div style={{ flex: 1 }}>
                    <div style={styles.natpis}>NAZIV GRADILIŠTA</div>
                    <input value={novoNaziv} onChange={e => setNovoNaziv(e.target.value)}
                      style={{ fontSize: "14px", height: "40px", padding: "10px", width: "100%" }} />
                  </div>
                  <div>
                    <CustomCalendarInput label="DATUM POČETKA" value={novoDatum} onChange={setNovoDatum} />
                  </div>
                </div>

                {/* Red 2 — zaposleni checkboxes */}
                <div style={{ marginTop: "8px" }}>
                  <div style={styles.natpis}>ZAPOSLENI KOJI PRATE GRADILIŠTE</div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", padding: "8px", background: "white", border: "1px solid #ccc", maxHeight: "80px", overflowY: "auto" }}>
                    {sviZaposleni.map(z => (
                      <label key={z.id} style={{ display: "flex", alignItems: "center", gap: "4px", cursor: "pointer", fontSize: "16px" }}>
                        <input
                        style={{ width: "25px", height: "25px", fontSize: "16px" }}
                          type="checkbox"
                          checked={odabraniZaposleni.includes(z.id)}
                          onChange={() => toggleZaposlen(z.id)}
                        />
                        {z.name}
                      </label>
                    ))}
                  </div>
                </div>

                {/* Dugmad */}
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "8px" }}>
                  <div onClick={() => { setIsDodavanjeGradiliste(false); setNovoNaziv(""); setNovoDatum(""); setOdabraniZaposleni([]); }}>
                    <Button activation={true} style={styles.button}>{dictionary["odustani"]}</Button>
                  </div>
                  <div onClick={novoNaziv ? handleDodajGradiliste : undefined} style={{ opacity: novoNaziv ? 1 : 0.5 }}>
                    <Button activation={true} style={styles.button}>{dictionary["sacuvaj"]}</Button>
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div onClick={() => setIsDodavanjeGradiliste(true)}>
                  <Button activation={true} style={styles.button}><span style={{ fontWeight: "bold" }}>{dictionary["dodaj"]}</span></Button>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default Pocetna;